/*
* ARCHIVO: src/app/providers.tsx
*
* MOTIVO:
* - layout.tsx es un Server Component.
* - GoogleOAuthProvider, AuthProvider y ThemeProvider necesitan ser Client Components.
* - Los agrupamos aquí con 'use client'.
*/

'use client';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { MotionConfig } from 'framer-motion';
import { AuthProvider } from './app/context/AuthContext';
import { ThemeProvider } from './app/context/ThemeContext';
import { CookieConsentProvider } from '@/contexts/CookieConsentContext';
import { Toaster } from 'sonner';

export function Providers({ children }: { children: React.ReactNode }) {
  const googleClientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;

  if (!googleClientId) {
    console.warn("Falta NEXT_PUBLIC_GOOGLE_CLIENT_ID en variables de entorno");
  }

  return (
    // Framer Motion anima con estilos inline desde JavaScript, así que la regla
    // `prefers-reduced-motion` de globals.css no la alcanza. `reducedMotion="user"`
    // hace que las 40 superficies que usan motion respeten la preferencia del
    // sistema sin tocarlas una a una: desactiva desplazamientos y escalados, y
    // conserva los fundidos de opacidad, que no disparan síntomas vestibulares.
    <MotionConfig reducedMotion="user">
      <GoogleOAuthProvider clientId={googleClientId || ""}>
        <ThemeProvider>
          <CookieConsentProvider>
            <AuthProvider>
              {children}
              {/* Non-blocking notices replace blocking browser dialogs (D1-12, D1-26). */}
              <Toaster position="bottom-right" />
            </AuthProvider>
          </CookieConsentProvider>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </MotionConfig>
  );
}